'use client'

import { type FC } from 'react'

import { useRecommendationIntersection } from '../../../../cross-sell'
import { useGlobalConfigContext } from '../../../../global-config'
import {
  RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE,
  RECOMMENDATION_WIDGET_BUY_TOGETHER,
  recommendationProductIsRenderable,
  RecommendationWidgetContainer,
  RecommendationWidgetProvider,
  useGetRecommendationWidgetId,
  useSwrFetchRecommendationService,
} from '../../../../recommendation'
import { useProductPageContext } from '../../productPageContext'

import { ProductRecommendationWidgetBuyTogetherContent } from './ProductRecommendationAreaBuyTogetherContent'
import { useProductRecommendationWidgetBuyTogetherProdRecActivation } from './useProductRecommendationAreaBuyTogetherProdRecActivation'
import { useProductRecommendationWidgetBuyTogetherRequestParams } from './useProductRecommendationAreaBuyTogetherRequestParams'

export const ProductRecommendationWidgetBuyTogether: FC = () => {
  const { locale } = useGlobalConfigContext()
  const { currentOffer, currentVariant } = useProductPageContext()
  const { handleIntersection, intersected } = useRecommendationIntersection()
  const serviceId = RECOMMENDATION_SERVICE_PDP_PRODUCT_AVAILABLE
  const sellerId = currentOffer?.seller?.sellerId ?? ''
  const requestParams = useProductRecommendationWidgetBuyTogetherRequestParams({
    currentVariantUpid: currentVariant.upid,
    intersected,
    sellerId,
    serviceId,
  })

  const widgetId = useGetRecommendationWidgetId(
    serviceId,
    RECOMMENDATION_WIDGET_BUY_TOGETHER,
  )

  const { data, error } = useSwrFetchRecommendationService(requestParams)
  useProductRecommendationWidgetBuyTogetherProdRecActivation(intersected)

  const widgetData = widgetId ? data?.recommendations[widgetId] : undefined
  const recommendedProductsWithAttributes = widgetData?.content.filter(
    ({ data: product }) =>
      recommendationProductIsRenderable({
        locale,
        product,
      }),
  )

  if (
    !widgetId ||
    !currentOffer ||
    error ||
    data?.recommendations[widgetId]?.content.length === 0 ||
    recommendedProductsWithAttributes?.length === 0
  ) {
    return null
  }

  const [recommendedProductWithAttributes] =
    recommendedProductsWithAttributes ?? []

  return (
    <RecommendationWidgetProvider
      serviceId={serviceId}
      widgetData={widgetData}
      widgetId={widgetId}
    >
      <RecommendationWidgetContainer
        className="flex flex-col"
        onIntersect={handleIntersection}
        widgetData={data}
        widgetId={widgetId}
      >
        <ProductRecommendationWidgetBuyTogetherContent
          currentOffer={currentOffer}
          currentVariant={currentVariant}
          recommendedProductWithAttributes={recommendedProductWithAttributes}
        />
      </RecommendationWidgetContainer>
    </RecommendationWidgetProvider>
  )
}
